<template>
  <div>
    <Top></Top>
    <div class="main">
      <h2>FBA直送サービス</h2>
      <div class="content">
        <p style="margin-top:50px">フルフィルメント by Amazon（FBA）は、Amazonの世界屈指の配送システムを活用し、</p>
        <p>商品の保管から注文処理・出荷・配送・返品に関するカスタマーサービスまでを提供するだけでなく、</p>
        <p>Amazon.co.jpでの販売力を強化し、売上拡大を支援するサービスです。</p>
        <p style="margin-top:100px">当社はお客様の需要に応じ、アマゾン倉庫への直送が可能です。</p>
        <p>現在では快速船便と航空便とも配送できます。</p>
        <p>
          詳細の利用料金は
          <router-link to="/freight">国際送料</router-link>と
          <router-link to="/option">オプション料金</router-link>で確認ください。
        </p>
        <ul>
          <li>
            <img src="../../assets/img/1-1.png" alt />
          </li>
          <li>
            <img src="../../assets/img/1-2.png" alt />
          </li>
          <li>
            <img src="../../assets/img/2-1.png" alt />
          </li>
          <li>
            <img src="../../assets/img/2-2.png" alt />
          </li>
        </ul>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../../components/head/Top";
import Foot from "../../components/foot/Foot";
export default {
  data() {
    return {};
  },
  components: {
    Top,
    Foot
  },
  methods: {}
};
</script>
<style lang='scss' scoped>
.main {
  width: 1200px;
  margin: 0 auto 150px;
  h2 {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin: 120px 0 80px;
  }
  .content {
    position: relative;
    overflow: hidden;
    height: 630px;
    background: url("../../assets/img/FBA_bg.png") no-repeat;
    background-size: 100% 100%;
    p {
      font-size: 28px;
      line-height: 40px;
      a {
        color: #226893;
        text-decoration: underline;
      }
    }
    ul {
      position: absolute;
      width: 280px;
      top: 280px;
      right: 0;
      li {
        width: 130px;
        margin: 0 0 10px 10px;
        float: left;
        img {
          width: 130px;
        }
      }
    }
  }
}
</style>